/* eslint-disable */
import * as schemas from './schemas';

export const horseSessionByDate = /* GraphQL */ `
  query HorseSessionByDate(
    $start: AWSTimestamp
    $end: AWSTimestamp
    $horse_id: ID!
    $workspace: Workspaces!
  ) {
    horseSessionByDate(
      start: $start
      end: $end
      horse_id: $horse_id
      workspace: $workspace
    ) {
      items {
        ${schemas.sessionSchema}
      }
      total
      nextToken
    }
  }
`;
export const getCustomerSessions = /* GraphQL */ `
  query GetCustomerSessions(
    $start: AWSTimestamp
    $end: AWSTimestamp
    $customer_horanet_id: ID!
    $workspace: Workspaces!
  ) {
    getCustomerSessions(
      start: $start
      end: $end
      customer_horanet_id: $customer_horanet_id
      workspace: $workspace
    ) {
      items {
        ${schemas.sessionSchema}
      }
      total
      nextToken
    }
  }
`;
export const getContentTypeSessions = /* GraphQL */ `
  query GetContentTypeSessions(
    $start: AWSTimestamp
    $end: AWSTimestamp
    $content_type_uuid: ID!
    $workspace: Workspaces!
    $content_type: String
    $nextToken: String
    $limit: Int
  ) {
    getContentTypeSessions(
      start: $start
      end: $end
      content_type_uuid: $content_type_uuid
      workspace: $workspace
      content_type: $content_type
      nextToken: $nextToken
      limit: $limit
    ) {
      items {
        ${schemas.sessionSchema}
      }
      total
      nextToken
    }
  }
`;
// deprecated
export const getSessionByHoranetId = /* GraphQL */ `
  query GetSessionByHoranetId($horanet_id: String!, $workspace: Workspaces!) {
    getSessionByHoranetId(horanet_id: $horanet_id, workspace: $workspace) {
      ${schemas.sessionSchema}
    }
  }
`;
export const getSession = /* GraphQL */ `
  query GetSession($id: ID!) {
    getSession(id: $id) {
      ${schemas.sessionSchema}
    }
  }
`;
export const listSessions = /* GraphQL */ `
  query ListSessions(
    $filter: ModelSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSessions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        ${schemas.sessionSchema}
      }
      nextToken
      startedAt
    }
  }
`;
export const syncSessions = /* GraphQL */ `
  query SyncSessions(
    $filter: ModelSessionFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSessions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        ${schemas.sessionSchema}
      }
      nextToken
      startedAt
    }
  }
`;
export const searchSessions = /* GraphQL */ `
  query SearchSessions(
    $filter: SearchableSessionFilterInput
    $sort: [SearchableSessionSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableSessionAggregationInput]
  ) {
    searchSessions(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        ${schemas.sessionSchema}
      }
      nextToken
      total
    }
  }
`;

export const getPreReservedParticipant = `
query getPreReservedParticipant($id: ID!) {
  getPreReservedParticipant(id: $id) {
    ${schemas.preReservedParticipantSchema}
  }
} 
`;

export const listPreReservedParticipants = `
query listPreReservedParticipants(
  $filter: ModelPreReservedParticipantFilterInput
  $limit: Int
  $nextToken: String
) {
  listPreReservedParticipants(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      ${schemas.preReservedParticipantSchema}
    }
    nextToken
    startedAt
  }
}
`

export const sessionsByRecurringUuid = `
query sessionsByRecurringUuid(
  $recurring_uuid: String!
  $limit: Int
  $filter: ModelSessionFilterInput
  $nextToken: String
) {
  sessionsByRecurringUuid(recurring_uuid: $recurring_uuid,filter: $filter,filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      ${schemas.sessionSchema}
    }
    nextToken
  }
}
`

export const getSessionByContentUuid = `
query getSessionByContentUuid($content_type: String!, $content_type_uuid: String!, $workspace: String!, $start_time: AWSTimestamp, $end_time: AWSTimestamp) {
  getSessionByContentUuid(content_type: $content_type, content_type_uuid: $content_type_uuid, workspace: $workspace, start_time: $start_time, end_time: $end_time) {
    items {
      ${schemas.sessionSchema}
    }
  }
}
`

export const customSessionSearch = /* GraphQL */ `
query customSessionSearch(
  $start: Int
  $limit: Int
  $query: AWSJSON
  $sort: AWSJSON
  $aggs: AWSJSON
  $nextToken: String
) {
  customSessionSearch(
    start: $start
    limit: $limit
    query: $query
    aggs: $aggs
    sort: $sort
    nextToken: $nextToken
  ) {
    nextToken
    items {
      ${schemas.sessionSchema}
    }
  }
}`;